import React, { Component, useState } from "react";
import Strings from "@my-dld/assets/strings";
import { convertToSqMt, ImperialSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import PortfolioContextWrapper, { Portfolio, PortfolioContext, ProxyPortfolio } from "@my-dld/contexts/PortfolioContext";
import PropertyTable from "@my-dld/components/Portfolio/PropertyTable";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import PropertyCard from "../../../components/Portfolio/PropertyCard";
import { getAppServices } from "@10x/coreapp";
import { getSiteRootUrl, RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { CurrencyUtil, I8N, LocaleUtil, StringUtil } from "@eres/core";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { FixCapNameX, formatAppDate, openPayment } from "@my-dld/utils/Utils";
import ListGridMapDataView from "@my-dld/components/DataView/ListGridMapDataView";
import { SpinnerLoader } from "@my-dld/components/SpinnerLoader";
import { GoogleMap, InfoWindow, Marker } from "react-google-maps";
import GMap from "@my-dld/components/GoogleMap";
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";
import {
	ManagementProfile,
	ManagementProfileEntry,
	OwnerCommitteeDetails,
	OwnerCommitteeEntry,
	Property,
	UnitProfile
} from "./MollakMeydaanAPI/entities";
import { MollakMeydaanAPI } from "./MollakMeydaanAPI";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { toTitleCase } from "../../../enocapi/services";
import CardNoData from "@my-dld/components/CardNoData";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import PaymentFrame from "../../TabuRequest/PaymentFrame";

interface Props extends RoutedViewProps<{ proxyId: string }> {

}

type Tab = "unitProfile" | "managementProfile" | "ownerCommittee";

interface State {
	unit: UnitSystem;
	mapReady: boolean;
	mapProperties?: Property[];
	selectedProperty?: Property;
	unitsList?: Property[];
	selectedTab?: Tab;
	unitDetails?: UnitProfile;
	managementProfile?: ManagementProfile;
	ownerCommitteeDetails?: OwnerCommitteeDetails;
}

class OwnedProperties extends Component<Props, State> {
	static contextType = PortfolioContext;
	context!: React.ContextType<typeof PortfolioContext>;
	payment = React.createRef<PaymentFrame>();

	constructor( props: Props ) {
		super( props );
		this.state = {
			unit: getAppServices().storeService.getStore().getState().User.unit,
			mapReady: false,
			selectedTab: "unitProfile",
		};
	}

	getBucket = (): Portfolio<AssetCard> | ProxyPortfolio<AssetCard> => {
		const proxyId = this.props.match.params.proxyId;
		let bucket = this.context.assets;
		if ( proxyId && !StringUtil.isEmptyStringOrNull( proxyId ) ) {
			const proxyBucket = this.context.proxyAssets?.find( x => x.id + "" === proxyId + "" );
			if ( proxyBucket ) return proxyBucket;
		}
		return bucket;
	};

	render() {
		let bucket = this.getBucket();
		const { isLoading, lands, units, villas } = bucket;
		const { name } = bucket as ProxyPortfolio<any>;
		const isDataFound = ( lands && lands.length > 0 ) || ( villas && villas.length > 0 ) || ( units && units.length > 0 );
		const title = name ? FixCapNameX( getLocalValue( name ) ) : Strings.owned_properties;
		return <ListGridMapDataView
			isLoading={ isLoading }
			dataAvailable={ isDataFound }
			title={ title }
			onViewTypeChange={ this.onViewTypeChange }
			onUnitSystemChange={ this.onUnitChange }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }
			renderMapView={ this.renderMapView }>
		</ListGridMapDataView>;
	}

	private onViewTypeChange = () => {
		this.setState( {
			selectedTab: "unitProfile",
			selectedProperty: undefined,
			unitsList: undefined,
			managementProfile: undefined,
			unitDetails: undefined
		} );
	};

	private onUnitChange = ( unit: UnitSystem ) => {
		this.setState( { unit: unit } );
	};

	private renderListView = () => {
		const { lands, units, villas, version } = this.getBucket();
		return <React.Fragment>
			{ lands && lands.length > 0 && <PropertyTable
				key={ version + "-lnd" } type={ TabuPropertyType.LAND }
				properties={ lands } unit={ this.state.unit }/> }
			{ villas && villas.length > 0 && <PropertyTable
				key={ version + "-villa" } type={ TabuPropertyType.VILLA }
				properties={ villas } unit={ this.state.unit }/>
			}
			{ units && units.length > 0 && <PropertyTable
				key={ version + "-unit" } type={ TabuPropertyType.UNIT }
				properties={ units } unit={ this.state.unit }/>
			}
		</React.Fragment>;
	};

	private renderGridView = () => {
		const { lands, units, villas, version } = this.getBucket();
		return <React.Fragment>
			{ lands && lands.length > 0 && <div className="land">
				<PropertyCard
					key={ version + "-lnd" } type={ TabuPropertyType.LAND }
					properties={ lands } unit={ this.state.unit }/>
			</div> }
			{ villas && villas.length > 0 && <div className="villa">
				<PropertyCard
					key={ version + "-villa" } type={ TabuPropertyType.VILLA }
					properties={ villas } unit={ this.state.unit }/>
			</div> }
			{ units && units.length > 0 && <div className="unit">
				<PropertyCard
					key={ version + "-unit" } type={ TabuPropertyType.UNIT }
					properties={ units } unit={ this.state.unit }/>
			</div> }
		</React.Fragment>;
	};

	private selectBuilding = ( units: Property[] ) => {
		this.setState( {
			unitsList: units,
			unitDetails: undefined,
			managementProfile: undefined,
			ownerCommitteeDetails: undefined,
			selectedTab: "unitProfile",
			selectedProperty: undefined,
		}, () => window.$( `[data-bs-toggle="tooltip"]` ).tooltip() );
	};

	private getUnitDetails = () => {
		if ( this.state.selectedProperty == null ) return;
		showLoading();
		MollakMeydaanAPI.getUnitDetails( this.state.selectedProperty?.propertyId! )
		.then( ( r ) => {
			hideLoading();
			if ( r && r.unit ) {
				const details = r as UnitProfile;
				this.setState( { unitDetails: details }, () => window.$( `[data-bs-toggle="tooltip"]` ).tooltip() );
			}
		} )
		.catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	};

	private getManagementProfile = () => {
		if ( this.state.selectedProperty == null ) return;
		showLoading();
		MollakMeydaanAPI.getManagementProfile( this.state.selectedProperty?.propertyId! )
		.then( ( r ) => {
			hideLoading();
			if ( r ) {
				this.setState( { managementProfile: r }, () => {
					this.configDataTable();
				} );
			}
		} )
		.catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	};

	private getOwnerCommitteeDetails = () => {
		if ( this.state.selectedProperty == null ) return;
		showLoading();
		MollakMeydaanAPI.getOwnerCommitteeDetails( this.state.selectedProperty?.propertyId! )
		.then( ( r ) => {
			hideLoading();
			if ( r ) {
				this.setState( { ownerCommitteeDetails: r }, () => {
					this.configDataTable();
				} );
			}
		} )
		.catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	};

	private ratingsBetween( min: Number, max: Number ) {
		return Number( this.state.unitDetails?.happiness?.value ) >= min && Number( this.state.unitDetails?.happiness?.value ) <= max;
	}

	private getHappinessRatings = () => {
		if ( this.ratingsBetween( this.state.unitDetails?.happiness?.range.red.min!, this.state.unitDetails?.happiness?.range.red.max! ) ) {
			return 1; // RED
		} else if ( this.ratingsBetween( this.state.unitDetails?.happiness?.range.orange.min!, this.state.unitDetails?.happiness?.range.orange.max! ) ) {
			return 2; // ORANGE
		} else if ( this.ratingsBetween( this.state.unitDetails?.happiness?.range.yellow.min!, this.state.unitDetails?.happiness?.range.yellow.max! ) ) {
			return 3; // YELLOW
		} else if ( this.ratingsBetween( this.state.unitDetails?.happiness?.range.lightGreen.min!, this.state.unitDetails?.happiness?.range.lightGreen.max! ) ) {
			return 4; // LIGHT GREEN
		} else {
			return 5; // GREEN
		}
	};

	private selectProperty = ( e: React.ChangeEvent<HTMLSelectElement> ) => {
		const propertyId = e.target.value;
		const property = this.state.unitsList?.find( p => p.propertyId + "" === propertyId + "" );
		this.setState( {
			selectedProperty: property,
			unitDetails: undefined,
			managementProfile: undefined,
			ownerCommitteeDetails: undefined,
			selectedTab: "unitProfile"
		}, () => {
			this.getUnitDetails();
		} );
	};

	private backToMap = () => {
		this.setState( { selectedProperty: undefined, unitsList: undefined } );
	};

	private onSelectUnitTab = ( e: React.MouseEvent<HTMLAnchorElement, MouseEvent> ) => {
		e.preventDefault();
		this.setState( { selectedTab: "unitProfile" } );
	};

	private onSelectManagementTab = ( e: React.MouseEvent<HTMLAnchorElement, MouseEvent> ) => {
		e.preventDefault();
		this.setState( { selectedTab: "managementProfile" } );
		if ( this.state.managementProfile == null ) {
			this.getManagementProfile();
		}
	};

	private onSelectOwnerCommitteeTab = ( e: React.MouseEvent<HTMLAnchorElement, MouseEvent> ) => {
		e.preventDefault();
		this.setState( { selectedTab: "ownerCommittee" } );
		if ( this.state.ownerCommitteeDetails == null ) {
			this.getOwnerCommitteeDetails();
		}
	};

	private configDataTable = () => {
		try {
			window.$( "#facilitiesManager" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			window.$( "#ownerAffairsManager" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			window.$( "#financialManager" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			window.$( "#complianceOfficer" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			window.$( "#owerCommitteeDetail" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};

	private onDownloadStatement = ( e: React.MouseEvent<HTMLAnchorElement, MouseEvent> ) => {
		e.preventDefault();
		if ( this.state.selectedProperty == null ) return;
		MollakMeydaanAPI.downloadStatement( this.state.selectedProperty?.propertyId );
	};

	private onPay = ( e: React.MouseEvent<HTMLAnchorElement, MouseEvent> ) => {
		e.preventDefault();
		if ( this.state.unitDetails?.serviceCharge?.paymentLink ) {
			this.openPaymentUrl( this.state.unitDetails?.serviceCharge?.paymentLink, this );
		}
	};

	private openPaymentUrl( paymentUrl: string, ref: any ) {
		let win: Window | null = null;
		let handled = false;
		window.name = "MyDLD";
		const listener = ( event: any ) => {
			const data: any = event.data;
			if ( data ) {
				const type = data.type;
				if ( type === "eres_pay" ) {
					if ( this.payment.current )
						this.payment.current.dismiss();
					// this.setState( { paymentUrl: undefined } );
					window.removeEventListener( "message", listener );
					window.open( "", "MyDLD" )?.focus();
					if ( win ) {
						handled = true;
						if ( win.close )
							win.close();
						window.focus();
					}
					setTimeout( () => {
						hideLoading();
						if ( data.data ) {
							const rsp = data.data;
							const status: string | undefined = data.data.PaymentStatus ?? data.data.paymentStatus;
							if ( status && status.toLowerCase() === "completed" ) {
								// this.onPaymentComplete( rsp );
							} else {
								// this.trackPSEvent( "PaymentFailed" );
								let message = Strings.payment_failed;
								if ( rsp && rsp.error != null ) message = message + "\n" + rsp.error;
								// this.setState( { paymentMessage: message }, JQModal( "message_action" ).show );
								showErrorMessage( message );
							}
						}
					}, 1 );
				}
			}
		};
		window.addEventListener( "message", listener, false );
		win = openPayment( paymentUrl );
		if ( win ) {
			showLoading();
			const pollTimer = window.setInterval( function () {
				if ( !handled && win!.closed ) {
					window.clearInterval( pollTimer );
					window.removeEventListener( "message", listener );
					ref.getUnitDetails();
					hideLoading();
				}
			}, 200 );
		} else {
			showErrorMessage( "Enable Popup window to continue" );
		}
	}

	private renderMapView = () => {
		const p = getAppServices().storeService.getStore().getState().UserData.mapProperties ?? [];
		const grouped: Record<string, Property[]> = {};
		p.forEach( ( property ) => {
			const building = property.building.name.englishName;
			grouped[ building ] = grouped[ building ] || [];
			grouped[ building ].push( property );
		} );
		console.log( "property ----- >", p );
		const buildings = Object.values( grouped ?? {} );
		const building = this.state.unitsList?.[ 0 ];
		const propertyType = Array.from( new Set( this.state.unitsList?.map( u => LocaleUtil.getLocalValue( u.propertyType ) as string ) ) ).join( ", " );
		const buildingName = LocaleUtil.getLocalValue( building?.building.name );
		const propertyGroupName = LocaleUtil.getLocalValue( building?.propertyGroupName );
		const area = LocaleUtil.getLocalValue( building?.building.area );
		const masterCommunity = LocaleUtil.getLocalValue( building?.building.masterCommunity );
		const oaCompany = LocaleUtil.getLocalValue( building?.oaCompany.name );
		const medal = building?.oaCompany.medal.englishName.toLowerCase();
		const score = building?.oaCompany.score;
		const unitDetails = this.state.unitDetails;
		const managementProfile = this.state.managementProfile;
		const ownerCommitteeDetails = this.state.ownerCommitteeDetails;
		const unitSize = this.state.unit;

		if ( !buildings || buildings.length === 0 ) {
			return <CardNoData containerClass="alert alert-warning"/>;
		}
		return <div className={ "mollak-map-wrap" }>
			{ this.state.unitsList != null ? <div className="mollak-map-content">
				<div className="property-summary-panel ps-3">
					<div className="col-group-1">
						<div className="column">
							<div
								className="val" data-bs-toggle="tooltip" data-placement="top"
								data-bs-original-title={ propertyGroupName }>{ propertyGroupName }</div>
							<div className="lbl">{ Strings.property_group }</div>
						</div>
						<div className="separator"></div>
						<div className="column">
							<div
								className="val" data-bs-toggle="tooltip" data-placement="top"
								data-bs-original-title={ buildingName }>{ buildingName }</div>
							<div className="lbl">{ Strings.building_name }</div>
						</div>
						<div className="separator"></div>
						<div className="column">
							<div
								className="val" data-bs-toggle="tooltip" data-placement="top"
								data-bs-original-title={ area }>{ area }
							</div>
							<div className="lbl">{ Strings.area }</div>
						</div>
						<div className="separator"></div>
						<div className="column">
							<div
								className="val" data-bs-toggle="tooltip" data-placement="top"
								data-bs-original-title={ propertyType }>{ propertyType }</div>
							<div className="lbl">{ Strings.property_type }</div>
						</div>
						<div className="separator"></div>
						<div className="column">
							<div
								className="val" data-bs-toggle="tooltip" data-placement="top"
								data-bs-original-title={ masterCommunity }>{ masterCommunity }
							</div>
							<div className="lbl">{ Strings.master_community }</div>
						</div>
						<div className="separator"></div>
						<div className="d-flex align-items-center column-h">
							<div className="column">
								<div
									className="val" data-bs-toggle="tooltip" data-placement="top"
									data-bs-original-title={ oaCompany }>{ oaCompany }
								</div>
								<div className="lbl">{ Strings.management_company }</div>
							</div>
							<div className="column ps-2">
								<img
									src={ getSiteRootUrl() + `assets/img/medal-${ medal }.png` } className="" alt="medal icon"
									data-bs-toggle="tooltip" data-placement="top"
									data-bs-original-title={ Strings.company_achieved.format( toTitleCase( medal + "" ) + "", ( score ?? 0 ) + "" ) }/>
							</div>
						</div>
						<div className="separator"></div>
						{ this.state.unitDetails?.happiness && <div className="column">
							<img
								src={ getSiteRootUrl() + `assets/img/happiness-score-${ this.getHappinessRatings() }.svg` }
								className="" alt="happiness icon"
								data-bs-toggle="tooltip" data-placement="top"
								data-bs-original-title={ `${ Strings.happiness_meter } : Score - ${ this.state.unitDetails.happiness.value ?? 0 }` }/>
						</div> }
					</div>
					<div className="col-group-2">
						<div className="column">
							<div className="position-relative pe-lg-2 field-style">
								<select onChange={ this.selectProperty } className="form-select dropdown-chosen form-select-sm" id="unitNo">
									<option value="0">{ Strings.select_unit }</option>
									{ this.state.unitsList.map( unit => <option
										value={ unit.propertyId } key={ unit.propertyId }>{ unit.propertyNumber }</option> ) }
								</select>
							</div>
						</div>
					</div>
				</div>
				{ this.state.selectedProperty ? <div className="tabs content-section pt-3" id="tabsUnitdetails">
					<nav className="transformer-tabs">
						<ul>
							<li className="nav-item">
								<a
									className={ `nav-link ${ this.state.selectedTab === "unitProfile" ? "active" : "" }` } id="unitProfile-tab"
									href="#" onClick={ this.onSelectUnitTab }>
									{ Strings.unit_profile }
								</a>
							</li>
							<li>
								<a
									className={ `nav-link ${ this.state.selectedTab === "managementProfile" ? "active" : "" }` }
									id="managementProfile-tab"
									href="#" onClick={ this.onSelectManagementTab }>
									{ Strings.management_profile }
								</a>
							</li>
							<li>
								<a
									className={ `nav-link ${ this.state.selectedTab === "ownerCommittee" ? "active" : "" }` }
									id="ownerCommittee-tab"
									href="#" onClick={ this.onSelectOwnerCommitteeTab }>
									{ Strings.owner_committee_details }
								</a>
							</li>
						</ul>
						<button
							id="btnBackToMap" type="button" className="btn btn-sm btn_1" onClick={ this.backToMap }>{ Strings.back_to_map }</button>
					</nav>
					{ unitDetails != null ? <div className={ this.state.selectedTab === "unitProfile" ? "active" : "" } id="unitProfile">
						<div className="content-section-title">
							<span className="section-title-span">{ Strings.unit_details }</span>
						</div>
						<div className="flex-grid-col-3">
							<div className="flex-grid flex-order">
								<div><span>{ Strings.unit_number }</span><span><span>{ unitDetails?.unit.unitNumber }</span></span></div>
								<div>
									<span>{ Strings.suite_area }</span><span><span>{ unitSize.Id === ImperialSystem.Id ? unitDetails?.unit.suiteArea : convertToSqMt( Number( unitDetails?.unit.suiteArea ) ) }</span></span>
								</div>
								<div>
									<span>{ Strings.balcony_area }</span><span><span>{ unitSize.Id === ImperialSystem.Id ? unitDetails?.unit.balconyArea : convertToSqMt( Number( unitDetails?.unit.balconyArea ) ) }</span></span>
								</div>
								<div>
									<span>{ Strings.service_charge_area }</span><span><span>{ unitSize.Id === ImperialSystem.Id ? unitDetails?.unit.applicableArea : convertToSqMt( Number( unitDetails?.unit.applicableArea ) ) }</span></span>
								</div>
								<div><span>{ Strings.mollak_id }</span><span><span>{ unitDetails.unit.mollakId }</span></span></div>
								{/*<div><span>{ Strings.ownership_date }</span><span><span>{ "" }</span></span></div>*/ }
								<div><span>{ Strings.type }</span><span><span>{ LocaleUtil.getLocalValue( unitDetails.unit.type ) }</span></span>
								</div>
							</div>
						</div>
						{ unitDetails?.resident ? <React.Fragment>
							<div className="content-section-title">
								<span className="section-title-span">{ Strings.resident_details  }</span>
								{/*<a href="#" className="btn btn-sm btn_1">View Ejari Certificate</a>*/ }
							</div>
							<div className="flex-grid-col-2">
								<div className="flex-grid flex-order">
									<div>
										<span>{ Strings.name }</span><span><span>{ LocaleUtil.getLocalValue( unitDetails.resident.name ) ?? "-" }</span></span>
									</div>
									<div><span>{ Strings.email }</span><span><span>{ unitDetails.resident.email ?? "-" }</span></span></div>
									<div><span>{ Strings.mobile }</span><span><span>{ unitDetails.resident.mobile ?? "-" }</span></span></div>
									<div>
										<span>{ Strings.type }</span><span><span>{ Strings[ unitDetails.resident.type.toLowerCase() ] ?? "-" }</span></span>
									</div>
									<div>
										<span>{ Strings.tenancy_start_date }</span><span><span>{ formatAppDate( unitDetails.resident.tenancyStart ) ?? "-" }</span></span>
									</div>
									<div>
										<span>{ Strings.tenancy_end_date }</span><span><span>{ formatAppDate( unitDetails.resident.tenancyEnd ) ?? "-" }</span></span>
									</div>
								</div>
								<div className="row">
									<div className="col-12">
										<div className="d-flex flex-row-reverse gap-2"></div>
									</div>
								</div>
							</div>
						</React.Fragment> : null }
						{ unitDetails.serviceCharge ? <React.Fragment>
							<div className="content-section-title">
								<span className="section-title-span">{ Strings.service_charge_status }</span>
							</div>
							<div className="flex-grid-col-3">
								<div className="flex-grid flex-order">
									<div>
										<span>{ Strings.outstanding_balance }</span><span><span>{ CurrencyUtil.toFormattedCurrency( Number( unitDetails.serviceCharge.outstanding ) ) + " " + Strings.aed }</span></span>
									</div>
								</div>
								<div className="row">
									<div className="col-12">
										<div className="d-flex gap-2">
											{ unitDetails.serviceCharge.paymentLink ? <a
												className="btn btn_1"
												target={ "_blank" } onClick={ this.onPay }>{ Strings.pay_now }</a> : null }
											<a
												href="#" onClick={ this.onDownloadStatement }
												className="btn btn-grey">{ Strings.download_statement }</a>
										</div>
									</div>
								</div>
							</div>
						</React.Fragment> : null }
					</div> : null }
					{ managementProfile != null ?
						<div className={ this.state.selectedTab === "managementProfile" ? "active" : "" } id="managementProfile">
							{ managementProfile.ownerAffairManager && managementProfile.ownerAffairManager.length > 0 ?
								<>
									<div className="content-section-title">
										<span className="section-title-span">{ Strings.owners_affairs_manager }</span>
									</div>
									<ListDataView
										id={ "ownerAffairsManager" } items={ managementProfile.ownerAffairManager }
										renderListHeader={ () => <Header/> } renderListItem={ item => <Row entry={ item }/> } isSearchable={ false }/>
								</> : null }
							{ managementProfile.facilitiesManager && managementProfile.facilitiesManager.length > 0 ?
								<>
									<div className="content-section-title">
										<span className="section-title-span">{ Strings.facilities_manager }</span>
									</div>
									<ListDataView
										id={ "facilitiesManager" } items={ managementProfile.facilitiesManager }
										renderListHeader={ () => <Header/> } renderListItem={ item => <Row entry={ item }/> } isSearchable={ false }/>
								</> : null }
							{ managementProfile.complianceOfficer && managementProfile.complianceOfficer.length > 0 ?
								<>
									<div className="content-section-title">
										<span className="section-title-span">{ Strings.compliance_officer }</span>
									</div>
									<ListDataView
										id={ "complianceOfficer" } items={ managementProfile.complianceOfficer }
										renderListHeader={ () => <Header/> } renderListItem={ item => <Row entry={ item }/> } isSearchable={ false }/>
								</> : null }
							{ managementProfile.financialManagers && managementProfile.financialManagers.length > 0 ?
								<>
									<div className="content-section-title">
										<span className="section-title-span">{ Strings.financial_managers }</span>
									</div>
									<ListDataView
										id={ "financialManager" } items={ managementProfile.financialManagers }
										renderListHeader={ () => <Header/> } renderListItem={ item => <Row entry={ item }/> } isSearchable={ false }/>
								</> : null }
						</div> : null }
					{ ownerCommitteeDetails != null ?
						<div className={ this.state.selectedTab === "ownerCommittee" ? "active" : "" } id="ownerCommittee">
							{ ownerCommitteeDetails.owerCommitteeDetail && ownerCommitteeDetails.owerCommitteeDetail.length > 0 ?
								<>
									<div className="content-section-title">
										<span className="section-title-span">{ Strings.owner_committee_member }</span>
									</div>
									<ListDataView
										id={ "ownerAffairsManager" } items={ ownerCommitteeDetails.owerCommitteeDetail }
										renderListHeader={ () => <CommitteeHeader/> } renderListItem={ item => <CommitteeRow entry={ item }/> }
										isSearchable={ false }/>
								</> : null }
						</div> : null }
				</div> : null }
			</div> : null }
			{ buildings && buildings.length > 0 && this.state.selectedProperty == null ? <GMap
				containerElement={ <div className="google-map-box" style={ { minHeight: "600px" } } id={ `foo` }/> }
				mapElement={ <div id={ `tr-map` } className={ `transaction-map` } style={ { minHeight: "600px" } }/> }
				loadingElement={ <div
					style={ { width: `100%`, display: `flex`, minHeight: 300, alignItems: `center` } }>
					<SpinnerLoader extraClass={ "spinner-border-no-shift" }/>
				</div> }
				options={ {
					mapTypeControl: false,
					mapTypeId: "roadmap",
					fullscreenControl: false,
					streetViewControl: false,
					keyboardShortcuts: false
				} }
				googleMapURL={ `https://maps.googleapis.com/maps/api/js?key=` + window.apiConfig.googleMapKey }
				showCommunityOverlay={ true }
				onMapInitialized={ this.onMapInitialized }>
				{ this.state.mapReady ? <React.Fragment>
					<MarkerClusterer averageCenter={ true }>
						{ buildings.map( building => {
							const isSelected = building[ 0 ].building.name.englishName === this.state.unitsList?.[ 0 ].building.name.englishName;
							return <CustomMarker
								key={ building[ 0 ].building.name.englishName }
								building={ building }
								isSelected={ isSelected }
								onSelectBuilding={ building => this.selectBuilding( building ) }/>;
						} ) }
					</MarkerClusterer>
				</React.Fragment> : null }
				{ this.state.unitsList != null ?
					<div id="select_txt" className="g-map-captcha-text">{ Strings.please_select_unit }</div> : null }
			</GMap> : null }
		</div>;
	};

	private onMapInitialized = ( _map: GoogleMap ) => {
		this.setState( {
			mapReady: true,
		} );
	};
}

function CustomMarker(
	props: { building: Property[]; onSelectBuilding: ( building: Property[] ) => void; isSelected: boolean } ) {
	const [ show, setShow ] = useState( false );
	const { building, onSelectBuilding, isSelected } = props;

	const area = LocaleUtil.getLocalValue( building[ 0 ].building.area );
	const propertyType = Array.from( new Set( building?.map( u => LocaleUtil.getLocalValue( u.propertyType ) as string ) ) ).join( ", " );
	const masterCommunity = LocaleUtil.getLocalValue( building[ 0 ].building.masterCommunity );
	const buildingName = LocaleUtil.getLocalValue( building[ 0 ].building.name );
	return <Marker
		onMouseOver={ () => setShow( true ) }
		onMouseOut={ () => setShow( false ) }
		cursor={ "pointer" }
		onClick={ () => onSelectBuilding( building ) }
		icon={ {
			url: getSiteRootUrl() + `assets/property-icons/building-icon-${ isSelected ? "selected" : "default" }.svg`,
			scaledSize: new google.maps.Size( isSelected ? 40 : 30, isSelected ? 40 : 30 ),
		} }
		position={ new google.maps.LatLng( {
			lng: building[ 0 ].latitude,
			lat: building[ 0 ].longitude,
		} ) }>
		{ show ? <InfoWindow>
			<div className="map-tooltip">
				<div className="map-tip-location">
					<span>{ buildingName }</span>
					<span>{ area }</span>
				</div>
				<div className="map-tip-type">
					<div>
						<span>{ propertyType }</span>
						<span>{ Strings.property_type }</span>
					</div>
					<div>
						<span>{ masterCommunity }</span>
						<span>{ Strings.master_community }</span>
					</div>
				</div>
			</div>
		</InfoWindow> : null }
	</Marker>;
}

export function Row( props: { entry: ManagementProfileEntry | OwnerCommitteeEntry } ) {
	const { entry } = props;
	return <tr>
		<td data-label={ Strings.name }>{ LocaleUtil.getLocalValue( entry.name ) ?? "-" }</td>
		<td data-label={ Strings.email }>{ entry.email ?? "-" }</td>
		<td data-label={ Strings.mobile }>{ entry.mobile ?? "-" }</td>
	</tr>;
}

export function CommitteeRow( props: { entry: OwnerCommitteeEntry } ) {
	const { entry } = props;
	return <tr>
		<td data-label={ Strings.name }>{ LocaleUtil.getLocalValue( entry.name ) ?? "-" }</td>
		<td data-label={ Strings.designation }>{ LocaleUtil.getLocalValue( entry.designation ) ?? "-" }</td>
		<td data-label={ Strings.email }>{ entry.email ?? "-" }</td>
		<td data-label={ Strings.mobile }>{ entry.mobile ?? "-" }</td>
	</tr>;
}

export function Header() {
	return <tr>
		<th>{ Strings.name }</th>
		<th>{ Strings.email }</th>
		<th>{ Strings.mobile }</th>
	</tr>;
}

export function CommitteeHeader() {
	return <tr>
		<th>{ Strings.name }</th>
		<th>{ Strings.designation }</th>
		<th>{ Strings.email }</th>
		<th>{ Strings.mobile }</th>
	</tr>;
}


export default ( props: any ) => <PortfolioContextWrapper>
	<OwnedProperties { ...props }/>
</PortfolioContextWrapper>;
